// 🎯 Tipos de Mídia das Mensagens
export const MESSAGE_MEDIA_TYPES = {
  AUDIO: 'audio',
  VIDEO: 'video',
  IMAGE: 'image',
  APPLICATION: 'application',
  LOCATION: 'locationMessage',
  CONTACT: 'contactMessage',
  REACTION: 'reactionMessage',
  CALL_LOG: 'call_log',
};

// 🕐 Configurações de Timing
export const TIMING_CONFIG = {
  HOVER_DELAY: 300, // ms para esconder FloatingMessageActions
  DEBOUNCE_DELAY: 500, // ms para fetch de mensagens
  DOUBLE_CLICK_DELAY: 50, // ms para simular clique no "Mais opções"
};

// 📏 Configurações de Layout
export const LAYOUT_CONFIG = {
  MESSAGE_SPACING: {
    WITH_REACTIONS: '32px',
    BEFORE_REACTIONS: '8px',
    NORMAL: '2px',
  },
  QUOTED_MESSAGE_MAX_LENGTH: 100,
  FLOATING_ACTIONS_OFFSET: '55px',
};

// 🎨 Status de Acknowledgment (ACK)
export const ACK_STATUS = {
  PENDING: 0,     // Relógio - Enviando
  SENT: 1,        // Check simples - Enviado
  RECEIVED: 2,    // Check duplo - Entregue
  READ: 3,        // Check duplo azul - Lido
  PLAYED: 4,      // Check duplo verde - Reproduzido (áudio/vídeo)
  FAILED: 5,      // Check duplo azul - Falhou
};

// 🌐 Canais de Comunicação
export const COMMUNICATION_CHANNELS = {
  WHATSAPP: 'whatsapp',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
};

// 🔒 Configurações LGPD
export const LGPD_CONFIG = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  DELETE_MESSAGE_KEY: 'lgpdDeleteMessage',
  ENABLE_LGPD_KEY: 'enableLGPD',
};

// 📱 Breakpoints Responsivos
export const RESPONSIVE_BREAKPOINTS = {
  MOBILE: 'xs',
  TABLET: 'sm',
  DESKTOP: 'md',
  LARGE_DESKTOP: 'lg',
};

// 🚀 Actions do Reducer
export const MESSAGE_ACTIONS = {
  LOAD_MESSAGES: 'LOAD_MESSAGES',
  ADD_MESSAGE: 'ADD_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_REACTION: 'ADD_REACTION',
  DELETE_REACTION: 'DELETE_REACTION',
  RESET: 'RESET',
};

// 🎭 Tipos de Skeleton Loader
export const SKELETON_TYPES = {
  INITIAL: 'initial',
  LOAD_MORE: 'loadMore',
};

// 📊 Configurações de Paginação
export const PAGINATION_CONFIG = {
  INITIAL_PAGE: 1,
  MESSAGES_PER_PAGE: 20, // Ajuste conforme necessário
};

// 🎪 Mensagens do Sistema
export const SYSTEM_MESSAGES = {
  WELCOME: 'Diga olá para seu novo contato!',
  DELETED_BY_CONTACT: '🚫 Essa mensagem foi apagada pelo contato',
  DELETED_BY_USER: '🚫 Essa mensagem foi apagada',
  DELETED_LGPD: '🚫 _Mensagem apagada_',
  FORWARDED: 'Encaminhada',
  EDITED_PREFIX: 'Editada ',
  REACTED_BY_CONTACT: ' reagiu... ',
  REACTED_BY_USER: 'Você reagiu... ',
  DROP_FILE_HERE: 'Solte o arquivo aqui',
  FACEBOOK_POLICY: 'Você tem 24h para responder após receber uma mensagem, de acordo com as políticas do Facebook.',
  LOADING_CONVERSATION: 'Carregando conversa...',
  LOADING_MORE_MESSAGES: 'Buscando mensagens anteriores...',
};

// 🎯 Configurações de Reações
export const REACTION_CONFIG = {
  INVALID_REACTIONS: ['reaction', ''], // Reações que devem ser filtradas
  MIN_EMOJI_SIZE: '16px',
  MAX_EMOJI_SIZE: '20px',
  REACTION_AREA_OFFSET: '-28px',
  REACTION_SPACING: '4px',
};

// 🎨 Configurações de Cores (para facilitar tematização futura)
export const COLOR_PALETTE = {
  REACTION_USER_BACKGROUND: 'rgba(0, 150, 255, 0.15)',
  REACTION_USER_BORDER: 'rgba(0, 150, 255, 0.3)',
  REACTION_DEFAULT_BACKGROUND: 'rgba(255, 255, 255, 0.9)',
  REACTION_DEFAULT_BORDER: 'rgba(0, 0, 0, 0.1)',
  REACTION_SHADOW: '0 2px 4px rgba(0, 0, 0, 0.1)',
  PRIVATE_MESSAGE_BACKGROUND: '#F0E68C',
  CONTACT_NAME_COLOR: '#6bcbef',
  TIMESTAMP_COLOR: '#999',
  FORWARD_MESSAGE_COLOR: 'grey',
  DELETED_MESSAGE_COLOR: '#f55d65',
};
